import { mainAxios } from "../../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "../mainService";

export const getUbicacionesCP = async (cp) => {
  try {
    const response = await mainAxios.get(
      `/v1/catalogo/direccion?cp=`+cp,
      getDefaultHeaders()
    );

    return response.data;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};